import type { ModelItem, ModelKey } from "./model.type";

import { useNavigate } from "react-router";

import { getModelLink } from "./model.helper";

export const useModelNavigate = () => {
  const navigate = useNavigate();

  const navigateToItem = (modelKey: ModelKey, item?: ModelItem) => {
    const link = getModelLink(modelKey, item);
    if (link) navigate(link);
  };

  return {
    navigateToItem,
  };
};
